/**
 * Notification log (supervisor/admin) — read-only audit of dispatched
 * notifications. Keeps the previous page visible while filtering/paging so the
 * table doesn't flash empty.
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { NotificationLogResponse } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

export interface NotificationLogFilters {
  channel?: string;
  status?: string;
  event?: string;
  q?: string;
  limit?: number;
  offset?: number;
}

export function useNotificationsLog(filters: NotificationLogFilters) {
  const params = new URLSearchParams();
  if (filters.channel) params.set('channel', filters.channel);
  if (filters.status) params.set('status', filters.status);
  if (filters.event) params.set('event', filters.event);
  if (filters.q) params.set('q', filters.q);
  params.set('limit', String(filters.limit ?? 50));
  params.set('offset', String(filters.offset ?? 0));

  return useQuery<NotificationLogResponse>({
    queryKey: ['notifications-log', filters],
    queryFn: () => apiCall<NotificationLogResponse>(`/notifications/log?${params.toString()}`),
    placeholderData: keepPreviousData,
  });
}
